import { Row, Col } from 'antd'
import { useDispatch, useSelector } from 'react-redux'

import { Button } from 'App/components'
import { createProcessingSelector, repostAdvertRequest, REPOST_ADVERT } from 'store'

export type TRepostAdvertDialogProps = {
  advertId: string
}

const processingRequest = createProcessingSelector([REPOST_ADVERT])

export const RepostAdvertDialog = (props: TRepostAdvertDialogProps) => {
  const dispatch = useDispatch()
  const processing = useSelector(processingRequest)

  const handleClick = () => {
    dispatch(repostAdvertRequest(props))
  }

  return (
    <Row gutter={[0, 28]}>
      <Col xs={24}>
        <Row justify="center">
          <span>Are you sure you want to repost this Advert?</span>
        </Row>
      </Col>
      <Col xs={24}>
        <Row justify="center">
          <Button loading={processing} onClick={handleClick}>
            Repost
          </Button>
        </Row>
      </Col>
    </Row>
  )
}
